import React from "react";
import "../Subpage/WelcomeTextStyle.css";

function WelcomeText() {
  return (
    <>
      <div className="heading">
        <section className="Text">
          <h1>Welcome To Our</h1>
          <div className="content">
            <h2>छठपूजा</h2>
            <h2>छठपूजा</h2>
          </div>
          <h1>Committee!</h1>
        </section>
      </div>
    </>
  );
}

export default WelcomeText;
